module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_sac_m.7fdfb8397d2e4c0049111d168398f10c.png";